import {Bootstrap} from "./Bootstrap";
import {MountManager} from "./MountManager";
Bootstrap.init();
MountManager.init();